//src/pages/REG/REG200F1.jsx
import React, {useContext, useEffect, useState} from 'react';
import style from "./REG200F1.module.scss";
import Button from "components/Button/Button";
import InputUnitText from "components/InputText/InputUnitText";
import DatePicker from "components/DatePicker/DatePicker";
import {dateToYMD, ymdToDate} from './REGComUtil'; //
import {postData} from 'utils/TransactionUtil';
import {AuthContext} from "contexts/AuthContext";
import styleCom from "./REGCOM.module.scss";
import SelectBox from "../../components/SelectBox/SelectBox";
import DataGrid from "../../components/DataGrid/DataGrid";
import {MenuContext} from "pages/COM/COM001L1";


import Modal from "../../components/Modal/Modal";
import REG200F2 from "../RE/REG200F2";
import toast from "../../components/Toast/Toast";




// 페이지 시작
const REG200F1 = ({navBar: NavBar, isActive}) => {

    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기
    const [comHsptObj, setComHsptObj] = useState([]);
    const { addPage_manual } = useContext(MenuContext);



    const [selectedRow, setSelectedRow] = useState(null);


    const [isComCodeReady, setIsComCodeReady] = useState(false);    //검색조건
    const [isManager, setIsManager] = useState(false);    //관리자 역할


    const searchObj = [
        { name:"hsptCd", value:  userInfo.hsptCd},
        { name:"studyId", value: ''},
        { name:"fromDt", value: ''},
        { name:"toDt", value: ''},
        { name:"initial", value: ''}
    ];

    const [rows_subjectList, setRows_subjectList] = useState([]);
    const cols_subjectList = [
        { key: 'hsptNm',     name: '기관명',  width: '20%' },
        { key: 'studyId',     name: 'Study ID',  width: '10%' },
        { key: 'enrollDt',   name: 'Enroll Date',  width: '20%' },
        { key: 'initial',    name: '이니셜',  width: '15%'},
        { key: 'age',        name: '연령',    width: '10%'},
        { key: 'sexNm',      name: '성별',  width: '10%'},
        { key: 'task99Stat',  name: 'End Study',  width: '15%'}
    ];

    const [inputData, setInputData]  = useState(searchObj);


    //form load
    useEffect(() => {
        const fetchComCode = async () => {
            await getComDtlsData(); // 비동기 처리 가정
            setIsComCodeReady(true);
            if(userInfo.roleId==="200001"){
                setIsManager(true);
            }
        };
        fetchComCode();

    }, []);
    useEffect(() => {
        if (isComCodeReady && isActive) {
            getSubjectList();
        }
    }, [isComCodeReady, isActive]);


/*  ====================================================================================================*/

    const [isModalDelete, setIsModalDelete] = useState(false); //암호초기화
    const handleModalDelete_Close = (result=0) => {
        //팝업 닫기
        setIsModalDelete(false);
        if(result===1){
            //삭제 성공시 리스트갱신
            getSubjectList();
        }
    }



    //데이터 get, set
    const setItemValue = (name, value) => {
        setInputData(prevData =>
            prevData.map(item =>
                item.name === name && item.value !== value ? { ...item, value } : item
            )
        );
    };

    const getItemValue = (getName) =>{
        return inputData.find(item => item.name === getName).value;
    }



    //조회 버튼 클릭
    const handleClick_search = (e) => {
        getSubjectList();
    }

    //삭제 버튼 클릭
    const handleClick_delete = (e) => {
        if(selectedRow){
            setIsModalDelete(true);
        }else{
            toast({type: 'info', message: "대상을 선택하여 주십시오."});
        }
    }


    const insertSpace = (index) => {
        return new Array(index).fill("\u00A0").map((space, idx) => (
            <span key={idx}>{space}</span>
        ));
    };

    // 데이터 더블클릭
    const handleDoubleClick_DataGrid_row = (e) => {

       const reStatYn = 'Y';
       const param = {mstId:e.row.mstId, hsptCd: e.row.hsptCd};

       const selMenu = {
         menuCd:"REG300F1",
         menuId:"030003",
         menuPos:"연구 > edit",
         menuTl:"edit"
       }
       addPage_manual(selMenu, param, reStatYn); //화면 열기 - 변경 필요 현 하드 코딩되어 있음.
    }


    /* Call Service====================================================================================================*/
    async function getComDtlsData() {
        //공통 기관정보
        const param1 = {comGrpCd:"HSPT_CD"}
        const resultData1 = await postData("/getComDtlsCd", param1);
        setComHsptObj(resultData1);
        setItemValue("hsptCd", userInfo.hsptCd);
    }

    /* 데이터 조회  
    * 
    * */    
    async function getSubjectList(){
        //메인 데이터 조회
        const getParam = Object.fromEntries(inputData.map(field => [field.name, field.value]));
        const res = await postData("/REW/getSubjectList", getParam);

        // // stat 값을 변환하는 재사용 가능한 함수
         const convertStatValue = (value) => {
             switch (value) {
                 case 'A':
                     return '🔴';
                 case 'B':
                     return '🔵';
                 case 'C':
                     return '🟢';
                 default:
                     return '';
             }
         };

         const updatedList = res.map(row => {
             return {
                 ...row,
                 // task1Stat: convertStatValue(row.task1Stat),
                 // task2Stat: convertStatValue(row.task2Stat),
                 // task3Stat: convertStatValue(row.task3Stat),
                 // task4Stat: convertStatValue(row.task4Stat),
                 // task5Stat: convertStatValue(row.task5Stat),
                 task99Stat: convertStatValue(row.task99Stat)
             };
         });
         setRows_subjectList(updatedList);

        setRows_subjectList(updatedList);
    }
    
    
    return (
        <main className={styleCom.main_wrap}>
            <NavBar>
                {/*공통 영역*/}
                <div className={styleCom.search_wrap}>
                    <Button variant="Secondary" size="md" addStyle={{width: "78px", height: "40px"}}
                            onClick={handleClick_delete} visible={isManager}>
                        삭제
                    </Button>
                    <Button variant="Primary" size="md" addStyle={{width: "78px", height: "40px"}}
                            onClick={handleClick_search}>
                        조회
                    </Button>
                </div>
                <table className={style.search_table} style={{height: "72px", marginTop: "5px"}}>
                    <tbody>
                    <tr style={{alignContent: "center"}}>
                        <td className={style.content_typ1}>
                            연구기관
                        </td>
                        <td className={style.content_typ1}>
                            <SelectBox options={comHsptObj} value={getItemValue("hsptCd")}
                                       width={230}
                                       onChange={(value) => setItemValue("hsptCd", value)}
                                       isDisabled={true}
                                       isAllExpr={false}/>
                        </td>
                        <td className={style.content_typ1}> Enroll Date</td>
                        <td className={style.content_typ1}>
                            <div className={style.content_typ2}>
                                <DatePicker selDate={ymdToDate(getItemValue('fromDt'))}
                                            dateFormat={'yyyy-MM-dd'}
                                            onChange={(date) => setItemValue('fromDt', dateToYMD(date))}/>
                                {insertSpace(2)}~{insertSpace(2)}
                                <DatePicker selDate={ymdToDate(getItemValue('toDt'))}
                                            dateFormat={'yyyy-MM-dd'}
                                            onChange={(date) => setItemValue('toDt', dateToYMD(date))}/>
                            </div>
                        </td>
                        <td className={style.content_typ1}> Study ID</td>
                        <td className={style.content_typ1}>
                            <InputUnitText type={"text"} value={getItemValue('studyId')} unit={""}
                                           onChange={(value) => setItemValue('studyId', value)}/>
                        </td>
                        <td className={style.content_typ1}> Initial</td>
                        <td className={style.content_typ1}>
                            <InputUnitText type={"text"} value={getItemValue('initial')} unit={""}
                                           onChange={(value) => setItemValue('initial', value)}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </NavBar>
            {/*검색영역*/}
            <br/>
            <div className={styleCom.root_wrap} style={{height: "100%", overflowY: "scroll"}}>
                <div className={styleCom.title_wrap}>
                    <h3>Subject List</h3>
                </div>
                <div style={{marginTop: "10px"}}>
                    <DataGrid
                        cols={cols_subjectList}
                        rows={rows_subjectList}
                        rowHeight={37}
                        onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                        onCellClick={(e) => setSelectedRow(e.row)}
                        sortable={true}
                        isNodataView={true}
                    />
                </div>
            </div>

            <Modal
                open={isModalDelete}
                handle_Close={handleModalDelete_Close}
                title="데이터 삭제"
                width="736px"
                height="450px"
                isHeader={true}
                bottomBtnText={{cancel: "취소", confirm: "삭제(확인)"}}
                isBottom={true}>
                <REG200F2 handle_Close={handleModalDelete_Close}
                          tarSelectObj={selectedRow}
                />
            </Modal>
        </main>


    )
        ;
};


export default REG200F1;
